export default ({label, isRequired}) => !!label && `${label} ${isRequired ? '*' : ''}`;
